module.exports = "/_next/static/images/MLA-guide-hero-13706a4a8dbb2962a8e7a58109d1eef8.png";